<template>
    <div class="case-study-four-images flex flex-col-reverse md:flex-row  justify-start md:justify-between items-center md:items-start max-w-3xl mx-auto px-10" :class="{ 'flex-row-reverse' : image.leftRight }">
        <img :data-srcset="image.mobileImageOne[0].url" :class="{'mt-14 md:mt-100'  : image.addSpace }" class="lazyload md:w-1/4 border-solid border" />
        <div class="md:w-2/3">
            <picture>
                <source media="(max-width: 767px)" :data-srcset="image.mobileImageTwo[0].url"/>
                <source media="(min-width: 768px)" :data-srcset="image.desktopImageTwo[0].url"/>
                <img
                        v-if="image && image.desktopImageTwo && image.mobileImageTwo"
                        :data-src="image.desktopImageTwo[0].url"
                        class="lazyload block mx-auto md:mx-0 border-solid border mt-14 md:mt-0"
                />
            </picture>
            <picture>
                <source media="(max-width: 767px)" :data-srcset="image.mobileImageThree[0].url"/>
                <source media="(min-width: 768px)" :data-srcset="image.desktopImageThree[0].url"/>
                <img
                        v-if="image && image.desktopImageThree && image.mobileImageThree"
                        :data-src="image.desktopImageThree[0].url"
                        class="lazyload block mx-auto md:mx-0 border-solid border mt-14 md:mt-18"
                />
            </picture>
            <picture>
                <source media="(max-width: 767px)" :data-srcset="image.mobileImageFour[0].url"/>
                <source media="(min-width: 768px)" :data-srcset="image.desktopImageFour[0].url"/>
                <img
                        v-if="image && image.desktopImageFour && image.mobileImageFour"
                        :data-src="image.desktopImageFour[0].url"
                        class="lazyload block mx-auto md:mx-0 border-solid border mt-14 md:mt-18"
                />
            </picture>
        </div>
    </div>
</template>

<script>
    export default {
        name : 'case-study-four-images',

        props : {
            block : {
                type : Object,
                default : () => {}
            }
        },

        computed : {
            image(){
                return this.block.caseStudyImagesFourImages[0];
            }
        },

        mounted(){
        }
    }
</script>

<style lang="scss">
    .case-study-four-images {
        box-sizing : content-box;

        img {
            border-color : rgba(190,190,190,0.4);
        }
    }
</style>